// Ownership share of a token purchase — shown on the token card and on the
// Order Confirmed asset line.

const PERCENT_BASE = 100
const SHARE_DECIMALS = 2
/** Below this the share rounds to 0.00%, so it reads "<0.01%" instead. */
const MIN_VISIBLE_SHARE_PCT = 0.01

/** 500 of 1,250,000 → "0.04%". "-" when the total isn't known. */
export const formatOwnershipShare = (tokens: number, totalTokens: number): string => {
  if (totalTokens <= 0) return '-'
  const share = (tokens / totalTokens) * PERCENT_BASE
  if (share > 0 && share < MIN_VISIBLE_SHARE_PCT) return `<${MIN_VISIBLE_SHARE_PCT}%`
  return `${share.toFixed(SHARE_DECIMALS)}%`
}
